import { connect } from "react-redux";
import TagMismatchDetails from "./tagMismatchDetails";
import { bindActionCreators } from "redux";
import { tagApprovalDetails,tagMismatchApprove,tagMismatchReject} from "services/redux/approvals/salesApprovals/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";
import {
  postReportDetails,
  generateReport,
} from "services/redux/installation/materialRequisition/action";
import {
  getInventory,
  postGateInventory,
} from "services/redux/installation/inventoryCheckList/action";
import { getMateriaById } from "services/redux/sales/postSales/corporate/action";

const mapStateToProps = (state) => ({
  siteData: state.salesApprovalReducer.tagDetails,
  userProfile : state.loginReducer.userProfile,
  inventoryData: state.inventoryReducer.inventoryData,
  getMaterial: state.coporatePostLeadReducer.getMaterial,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInventory,
      tagMismatchApprove,
      tagMismatchReject,
      getMateriaById,
      postGateInventory,
      tagApprovalDetails,
      documentUploadUrl,
      postReportDetails,
      generateReport
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(TagMismatchDetails);
